<template>
  <v-card flat :loading="loading" class="col-md-12 px-2 py-5">
    <v-card-title v-if="title">{{ title }}</v-card-title>
    <v-card-subtitle v-if="subtitle !== ''">{{ subtitle }}</v-card-subtitle>
    <p class="font-size-h6 mt-5 font-weight-bold">
      تعداد نردبان باقی مانده :
      <span class="text-danger">{{ accountBalance }} </span>
    </p>
    <div class="col-md-12 mx-auto">
      <v-radio-group
        v-model="ladderId"
        v-for="(item, index) in ladders"
        :key="item.id"
        class="mt-0 pt-0"
      >
        <v-radio
          :value="item.id"
          class="py-0 my-0"
          style="border-bottom: 1px solid #f5f5f5"
        >
          <template v-slot:label>
            <div class="col-md-12 text-right my-0 py-0">
              <span>{{ item.title }}</span>
              <v-card-subtitle class="my-0 py-1 text-danger font-size-h6">{{
                item.price
              }}</v-card-subtitle>
              <v-card-subtitle
                v-if="item.subtitle"
                class="my-0 py-0 text-dark"
                >{{ item.subtitle }}</v-card-subtitle
              >
            </div>
          </template>
        </v-radio>
      </v-radio-group>

      <div class="col-md-12 mb-5 p-0">
        <v-btn @click="setSuggests" class="btn-payment float-start">
          <span class="fa fa-dollar-sign ml-1"></span>
          پرداخت مستقیم
        </v-btn>

        <v-btn @click="payCustom" class="btn-payment float-end">
          <span class="fa fa-dollar-sign ml-1"></span>
          پرداخت از کیف پول
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
import { Axios2 } from "@/main";
import { mapGetters } from "vuex";

export default {
  name: "chargeChecker",
  props: {
    data: "",
  },
  data() {
    return {
      loading: false,
      ladders: [],
      title: "",
      subtitle: "",
      ladderId: "",
      accountBalance: "",
    };
  },
  methods: {
    getSuggests() {
      this.loading = true;

      Axios2.get(`/divar/service/ladder/prices/${this.data}`)
        .then((response) => {
          this.loading = false;
          this.ladders = response.data.data;
        })
        .catch((err) => {
          this.$toast.error("خطای سمت سرور!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getTitle() {
      this.loading = true;

      Axios2.get(`/divar/service/check/${this.data}`)
        .then((response) => {
          this.loading = false;
          this.title = response.data.data.title;

          if (
            response.data.data.msg === "از نردبان کردن پروفایل خود مطمئنید؟"
          ) {
            this.subtitle = "امکان نردبان کردن پروفایل شما وجود دارد.";
          } else this.subtitle = "";
        })
        .catch((err) => {
          this.$toast.error("خطای سمت سرور!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    setSuggests() {
      let pack = this.core.pack[0];
      let hasPanel = [18, 19, 25, 26, 27].indexOf(pack.id) > 0;

      // this.usersPanel.forEach(item => hasPanel = hasPanel && [18, 19, 25, 26, 27].indexOf(item) > 0)

      if (!hasPanel) {
        this.$modal.error(
          "",
          "برای استفاده از پردخت مستقیم ابتدا باید پنل دیوار را خریداری فرمایید.",
          "",
          {
            text: "خرید پنل",
            icon: "fa-plus",
            class: "btn col-md-12 btn-outline-lightGreen my-1",
            onClick() {
              window.open(this.$coreApi + "/#/panel", "_blank");
            },
          }
        );
      } else {
        this.loading = true;
        Axios2.post(`/divar/service/ladder/order/${this.data}`, {
          id: this.ladderId,
        })
          .then((response) => {
            this.loading = false;
            if (response.data.data.order_id) {
              window.open(response.data.data.redirect, "_blank");
            } else this.$toast.error("انتخاب شما معتبر نیست!");
          })
          .catch((err) => {
            // this.$toast.error('خطای سمت سرور!')
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    payCustom() {
      this.loading = true;
      Axios2.post(`/divar/service/ladder/order/wallet/manual/${this.data}`, {
        id: this.ladderId,
      })
        .then((response) => {
          this.loading = false;
          this.$toast.success("پرداخت با موفقیت انجام شد.");
        })
        .catch((err) => {
          // console.log(err.code)
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAccountBalance() {
      this.loading = true;
      Axios2.get(`/divar/service/credit/${this.data}`)
        .then((response) => {
          this.loading = false;
          this.accountBalance = response.data.data.count;
        })
        .catch((err) => {
          this.$toast.error("خطای سمت سرور!");
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getTitle();
  },
  mounted() {
    this.getAccountBalance();
    this.getSuggests();
  },
  computed: {
    ...mapGetters("ribbon", {
      core: "core",
    }),
  },
};
</script>

<style scoped></style>
